export const calcInstallmentAmount = (
  fullPrice: number,
  installmentCount: number,
): string => (fullPrice / installmentCount).toFixed(2);
